import {
  getVendor,
  getVendorCount,
} from "../../../../actions/CarrierAgreementMgmt/Vendor";
import { useQuery } from "react-query";

export default function useVendorCount() {
  
  //Fetching Vendor Details
  return useQuery("GetVendorCount", getVendorCount, {
    refetchOnWindowFocus: false,
  });
}
